import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import AuthScreen from './pages/AuthScreen';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import NewClient from './pages/NewClient';
import Schedule from './pages/Schedule';
import Money from './pages/Money';
import Documents from './pages/Documents';
import PublicBooking from './pages/PublicBooking';
import EmbedBooking from './pages/EmbedBooking';
import Rebook from './pages/Rebook';
import ClientPortal from './pages/ClientPortal';
import EmbedCode from './pages/EmbedCode';
import NewMeeting from './pages/NewMeeting';
import NewProduction from './pages/NewProduction';
import NewDocument from './pages/NewDocument';
import NewTransaction from './pages/NewTransaction';
import AIAssistant from './pages/AIAssistant';
import Settings from './pages/Settings';
import Install from './pages/Install';
import Join from './pages/Join';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<AuthScreen />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/book" element={<EmbedBooking />} />
          <Route path="/book/:slug" element={<EmbedBooking />} />
          <Route path="/rebook/:token" element={<Rebook />} />
          <Route path="/portal/:token" element={<ClientPortal />} />
          <Route path="/install" element={<Install />} />
          <Route path="/join" element={<Join />} />
          <Route path="/embed-code" element={
            <ProtectedRoute>
              <EmbedCode />
            </ProtectedRoute>
          } />
          <Route path="/settings/booking-widget" element={
            <ProtectedRoute>
              <EmbedCode />
            </ProtectedRoute>
          } />
          
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/clients" element={
            <ProtectedRoute>
              <Clients />
            </ProtectedRoute>
          } />
          
          <Route path="/clients/new" element={
            <ProtectedRoute>
              <NewClient />
            </ProtectedRoute>
          } />
          
          <Route path="/clients/:id" element={
            <ProtectedRoute>
              <ClientDetail />
            </ProtectedRoute>
          } />
          
          <Route path="/schedule" element={
            <ProtectedRoute>
              <Schedule />
            </ProtectedRoute>
          } />
          
          <Route path="/money" element={
            <ProtectedRoute>
              <Money />
            </ProtectedRoute>
          } />
          
          <Route path="/documents" element={
            <ProtectedRoute>
              <Documents />
            </ProtectedRoute>
          } />
          
          <Route path="/meetings/new" element={
            <ProtectedRoute>
              <NewMeeting />
            </ProtectedRoute>
          } />
          
          <Route path="/productions/new" element={
            <ProtectedRoute>
              <NewProduction />
            </ProtectedRoute>
          } />
          
          <Route path="/documents/new" element={
            <ProtectedRoute>
              <NewDocument />
            </ProtectedRoute>
          } />
          
          <Route path="/transactions/new" element={
            <ProtectedRoute>
              <NewTransaction />
            </ProtectedRoute>
          } />
          
          <Route path="/ai" element={
            <ProtectedRoute>
              <AIAssistant />
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          } />
          
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
